import { LocaleCode } from "shared/types/languages";

export type TranslationsParams = {
  translationId: string;
  locale: LocaleCode | string;
  value: string;
};

export type TranslationInitialValueParams = {
  translationId: string;
  locale: LocaleCode | string;
}

export enum TranslationTypes {
  Dynamic = "dynamic",
  Static = "static",
}